import React from 'react';
import {connect} from 'react-redux';
import OpenExplore, {DisplayMode} from "../../../components/openexplore/OpenExplore/OpenExplore";
import {setOxMode} from "../../../store/ui/actions";

export class OpenExploreMapPage extends React.Component {

    componentWillMount() {
        this.props.setOxMode(DisplayMode.MODE_MAP);
    }

    render() {
        return <OpenExplore
            mode={DisplayMode.MODE_MAP}
            match={this.props.match}
        />
    }
}

function mapStateToProps(state, ownProps) {
    return {}
}

export default connect(mapStateToProps, {
    setOxMode
})(OpenExploreMapPage);



// WEBPACK FOOTER //
// src/containers/openexplore/OpenExploreMapPage/OpenExploreMapPage.js